/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

/**
 *
 * @class ProjectHistoryItem
 *
 * @brief this is a memento we keep in our "recent projects" list for a user.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectHistoryItem {

  public name: string = '';

  public key:  string = '';

  /** standard constructor */
  constructor(name: string, key: string) {

    this.name = name;
    this.key  = key;
  }

}
